<template>
  <div class="pageOverflow">
    <div class="pageFlex">
      <div class="block">
        <yz-daterange @dateRange="getChooseTime"></yz-daterange>
        <el-input v-model.trim="inputVal" class="input_s250" placeholder="请输入顾客姓名/手机尾号" @keyup.enter.native="search">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search"></i>
        </el-input>
      </div>
      <div class="manageInfo">
        <div class="content">
          <h4>还款总金额：{{ totalMoney }}</h4>
          <h5>现金：{{ totalCash }}</h5>
          <h5>银行卡：{{ totalBank }}</h5>
          <h5>会员卡：{{ totalVip }}</h5>
          <h5>
            微信：{{ (totalWXGF*1+totalWXTL*1).toFixed(2) }}
            <el-tooltip placement="right" effect="light">
              <div slot="content">
                <h5>微信（官方）：-￥{{ totalWXGF ? totalWXGF.toFixed(2) : '0.00' }}</h5>
                <h5>微信（通联）：-￥{{ totalWXTL ? totalWXTL.toFixed(2) : '0.00' }}</h5>
              </div>
              <i class="iconfont" style="color: #D2D2D2;font-size: 14px;">&#xe71a;</i>
            </el-tooltip>
          </h5>
          <h5>
            支付宝：{{ (totalZFBGF*1+totalZFBTL*1).toFixed(2) }}
            <el-tooltip placement="right" effect="light">
              <div slot="content">
                <h5>支付宝（官方）：-￥{{ totalZFBGF ? totalZFBGF.toFixed(2) : '0.00' }}</h5>
                <h5>支付宝（通联）：-￥{{ totalZFBTL ? totalZFBTL.toFixed(2) : '0.00' }}</h5>
              </div>
              <i class="iconfont" style="color: #D2D2D2;font-size: 14px;">&#xe71a;</i>
            </el-tooltip>
          </h5>
          <h5>个人微信：{{ totalPWX }}</h5>
          <h5>个人支付宝：{{ totalPZFB }}</h5>
        </div>
      </div>
      <div style="margin: 15px 0 45px 0;">
        <el-table v-loading="loading" :data="tableData" tooltip-effect="light">
          <el-table-column prop="createtimeStr" label="还款日期" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="orderCode" label="订单号" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="memberName" label="姓名" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.phone ? Lib.starPhone(scope.row.phone) : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cardNo" label="会员卡号" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="money" label="赊账金额（元）" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.money.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="还款金额（元）" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.money.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="payTypeName" label="还款方式" show-overflow-tooltip>
            <!-- <template slot-scope="scope">
              <span v-if="scope.row.refundway == 1">现金</span>
              <span v-else-if="scope.row.refundway == 2">银行卡</span>
              <span v-else-if="scope.row.refundway == 3">会员卡</span>
              <span v-else-if="scope.row.refundway == 4">扫码</span>
              <span v-else-if="scope.row.refundway == 7">个人微信</span>
              <span v-else-if="scope.row.refundway == 8">个人支付宝</span>
              <span v-else-if="scope.row.refundway == 9">微信支付（官方）</span>
              <span v-else-if="scope.row.refundway == 10">支付宝（官方）</span>
              <span v-else-if="scope.row.refundway == 11">微信（通联）</span>
              <span v-else-if="scope.row.refundway == 12">支付宝（通联）</span>
              <span v-else-if="scope.row.refundway == 13">微信（翼支付）</span>
              <span v-else-if="scope.row.refundway == 14">支付宝（翼支付）</span>
              <span v-else-if="scope.row.refundway == 21">赊账还款扣除</span>
            </template> -->
          </el-table-column>
          <el-table-column prop="dutyName" label="操作员" width="90" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="tableData.length > 0" class="allFooter">
        <el-pagination background :current-page.sync="currentPage" :page-sizes="[5, 10, 15, 20, 30, 40, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
        <i class="iconfont backTop" @click="Lib.backTop()">&#xe62f;</i>
      </div>
    </div>
  </div>
</template>

<script>
import { getZhkjl } from '../api';

export default {
  data() {
    return {
      value: '', // 时间段
      inputVal: '', // 搜索值
      currentPage: 1, // 当前页
      tableData: [], // 列表数据
      pageNum: 1, // 当前页
      pageSize: 15, // 每页数据量
      rowCount: '', // 列表总数
      totalBank: '', // 银行卡支付总数
      totalCash: '', // 现金支付总数
      totalMoney: '', // 还款总金额
      totalVip: '', // 会员支付总数
      totalWX: '', // 微信总数
      totalPWX: '', // 个人微信总数
      totalPZFB: '', // 个人支付宝总数
      totalWXGF: '', // 微信官方总数
      totalZFBGF: '', // 支付宝官方总数
      totalWXTL: '', // 微信通联总数
      totalZFBTL: '', // 支付宝通联总数
      // 5.7
      loading: true,
    };
  },
  activated() {
    this.getListData();
  },
  methods: {
    // 得到子组件选择的时间
    getChooseTime(time) {
      this.value = time;
      this.chooseTime(time);
    },
    // 选择时间
    chooseTime() {
      this.pageNum = 1;
      this.currentPage = 1;
      this.getListData();
    },
    // 搜索
    search() {
      this.Lib.keyboardBlur();
      this.pageNum = 1;
      this.currentPage = 1;
      this.getListData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    // 列表数据--渲染
    getListData() {
      const vm = this;
      const data = {
        startDate: '',
        endDate: '',
        keyWord: vm.inputVal,
        pageSize: vm.pageSize,
        pageNum: vm.pageNum
      };
      if (vm.value) {
        data.startDate = vm.value[0];
        data.endDate = vm.value[1];
      }
      vm.loading = true;
      getZhkjl(data).then((res) => {
        // console.log(res)
        vm.tableData = res.data.page.subList;
        vm.rowCount = res.data.page.rowCount;
        vm.totalBank = res.data.sumMap.totalBank;
        vm.totalCash = res.data.sumMap.totalCash;
        vm.totalMoney = res.data.sumMap.totalMoney;
        vm.totalVip = res.data.sumMap.totalVip;
        vm.totalWX = res.data.sumMap.totalWX;
        vm.totalPWX = res.data.sumMap.totalPWX;
        vm.totalPZFB = res.data.sumMap.totalPZFB;
        vm.totalWXGF = res.data.sumMap.totalWXGF;
        vm.totalZFBGF = res.data.sumMap.totalZFBGF;
        vm.totalWXTL = res.data.sumMap.totalWXTL;
        vm.totalZFBTL = res.data.sumMap.totalZFBTL;
        vm.loading = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.manageInfo {
  width: 100%;
  .content {
    background-color: #f5f7fa;
    height: 60px;
    padding: 0 15px;
    margin: 15px 0 0 0;
    display: flex;
    h4 {
      width: auto;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      color: #333;
      padding: 0 15px 0 0;
      margin: 0;
      float: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: 500;
      border-right: 10px solid #fff;
    }
    h5 {
      flex: 1;
      width: auto;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      color: #333;
      padding: 0 0 0 15px;
      margin: 0;
      float: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: 500;
    }
  }
}
</style>
